/* eslint-disable react/prop-types */
import React from "react";
import { Textarea } from "@nextui-org/input";

const CustomTextArea = ({
  labelPlacement,
  label,
  isDisabled,
  value,
  lableOpacity,
  error,
  errorMessage,
  onChange,
  name,
}) => {
  return (
    <div className="flex flex-col">
      <Textarea
        name={name}
        labelPlacement={labelPlacement ?? "outside"}
        label={label}
        variant="underlined"
        value={value}
        isDisabled={isDisabled}
        isInvalid={error}
        placeholder={isDisabled ? `` : `โปรดกรอก${label}`}
        onChange={onChange}
        classNames={{
          innerWrapper: "flex-grow",
          input: ["flex-grow bg-white", error && "placeholder:text-red-500"],
          base: ["flex-grow", "data-[disabled=true]:opacity-100"],
          label: [
            error ? "text-red-500" : "text-black",
            `opacity-${lableOpacity ?? 50}`,
          ],
          inputWrapper: [
            isDisabled
              ? [
                  "border-none",
                  "bg-transparent",
                  "shadow-none",
                  "!border-b-0",
                  "before:border-none",
                  "after:border-none",
                ]
              : [
                  "data-[hover=true]:bg-transparent",
                  error && [
                    "group-data-[focus=true]:after:!bg-red-500",
                    "group-data-[invalid=true]:after:!bg-red-500",
                    "group-data-[invalid=true]:before:!bg-red-500",
                    "group-data-[focus=true]:before:!bg-red-500",
                    "!border-red-500",
                  ],
                ],
            "data-[hover=true]:bg-transparent",
            "bg-white flex-grow",
          ],
        }}
      />
      {error && <p className="text-red-500 text-sm pt-1">{errorMessage}</p>}
    </div>
  );
};

export default CustomTextArea;
